import { z } from 'zod';

import { addressSchema } from './addressSchema';

export const profileSchema = z
  .object({
    fullName: z.string().min(1, 'Obrigatório'),
    email: z.string().email('Informe um e-mail válido'),
    phone: z
      .string()
      .default('')
      .refine(
        (value) => {
          const regex = /^\(\d{2}\) \d{5}-\d{4}$/;
          return regex.test(value);
        },
        {
          message: 'Informe um telefone válido',
        },
      ),

    password: z.string().optional().default(''),
    newPassword: z.string().optional().default(''),
    confirmPassword: z.string().optional().default(''),

    address: addressSchema,
  })
  .superRefine((data, ctx) => {
    const hasPassword = !!data.password;
    const hasNewPassword = !!data.newPassword;
    const hasConfirmPassword = !!data.confirmPassword;

    // Nenhum campo preenchido? OK
    if (!hasPassword && !hasNewPassword && !hasConfirmPassword) return;

    // Nova senha preenchida, mas faltam outros campos
    if (hasNewPassword) {
      if (!hasPassword) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ['password'],
          message: 'Obrigatório',
        });
      }
      if (!hasConfirmPassword) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ['confirmPassword'],
          message: 'Obrigatório',
        });
      }
    }

    // Antiga ou confirmação preenchidas, mas nova não
    if ((hasPassword || hasConfirmPassword) && !hasNewPassword) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['newPassword'],
        message: 'Obrigatório',
      });
    }

    // Nova senha e confirmação diferentes
    if (
      hasNewPassword &&
      hasConfirmPassword &&
      data.newPassword !== data.confirmPassword
    ) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['confirmPassword'],
        message: 'As senhas não coincidem',
      });
    }
  });

export type IProfileSchema = z.infer<typeof profileSchema>;
